<script setup lang="ts"></script>

<template>
  <NuxtLink to="/" aria-label="Zeno.FM logo">
    <NuxtImg class="h-6" src="/img/main-logo.svg" alt="Zeno FM logo" />
  </NuxtLink>
</template>

<style scoped></style>
